import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

const pageSize = 5;

const OatAddRolemain = () => {
  const[Roletable, setRoletable] =useState([])   
  const token = JSON.parse(localStorage.getItem('usertoken')); 
  const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);

  useEffect(()=>{
    getRole();
   
  },[])

 /*---Get Roles ----*/

function getRole(){


    fetch(`${BASE_URL}/Oat/GetOatRole`, {
      method:'GET',

    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " +`${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },


})

          .then(response => response.json())


            .then(data => {
             console.log("Role",data)
             setRoletable(data)
             setpaginatedPosts(_(data).slice(0).take(pageSize).value());
              localStorage.setItem("Data", JSON.stringify(data));
            });
           }
           const pageCount = Roletable? Math.ceil(Roletable.length/pageSize) :0;
           // if (pageCount === 1)
           // return null;
           
           const pages = _.range(1, pageCount+1)
           
           const pagination =(pageNo)=>{
           setcurrentPage(pageNo);
           const startIndex = (pageNo - 1) * pageSize;
           const paginatedPost = _(Roletable).slice(startIndex).take(pageSize).value();
           setpaginatedPosts(paginatedPost)
           }

           const onNext = () => {


            pagination(currentPage + 1);
          };
        
          const onPrevious = () => {
            pagination(currentPage - 1);
          };
      

      // -----AddRole-----//

  
  function handlesumbmit(){

    let alldata = localStorage.getItem("Data");
    let RoleName= document.getElementById("RoleName").value
    console.log(alldata.role)
  
    let roledata =  JSON.parse(alldata);
  console.log(roledata)
  
  
    let names = roledata.map((item) => item.role);
    console.log(names)
  
  
    let result = names.includes(RoleName);  
    console.log(result)  

 
   if(!RoleName){

    document.getElementById("ErrA").innerHTML="Role Required"
    document.getElementById("frown").style.display="block"
    document.getElementById("smile").style.display="none"
   }
   else if(RoleName){

    document.getElementById("ErrA").innerHTML=" "
    if(result==true){
      // toast.error(" Role Already Exists! ")
    //  alert(" Role Already Exists! ")
     document.getElementById("RoleExist-Oat").style.display="block"
     setTimeout(() => {
      document.getElementById("RoleExist-Oat").style.display="none"
     
    }, 3000);
     }
     else{

   

    const body ={
  
     Role:RoleName,
    }
   console.log(body);



  axios({

    method: "POST",

    url: `${BASE_URL}/Oat/OatAddRole`,
    data:body,
    headers: {
      
      'Content-Type': 'multipart/form-data' ,    
      "Authorization": "Bearer " +`${token}`
     
    }
  
  })
 
  .then((response) =>{
    console.log(response.data);
     if(response.data.status === "Success"){
      //  toast.success("Role Added Successfully!", {
      //          position: "top-center",
      //          autoClose: 3200,
      //          hideProgressBar: false,
      //          closeOnClick: true,
      //          pauseOnHover: true,
      //          draggable: true,
      //          progress: undefined,
      //          className: 'toast-message'
      //          });
             closeAddForm();
             getRole();
             setcurrentPage(1)
             document.getElementById("AddSuccess-Oat").style.display="block"

             // alert("Role Added Successfully!")
               setTimeout(() => {
                   
                document.getElementById("AddSuccess-Oat").style.display="none"
                  //  window.location.reload();
                 
               

               }, 3000);
             }
            
            })
     
   .catch(error => {
    console.log(error);
     alert(" Add Role failed !")       
     })
 
    }
  }
   }


  

  function handlechange(){

    var RoleName= document.getElementById("RoleName").value
   if(!RoleName){

    document.getElementById("ErrA").innerHTML="Role Required"
    document.getElementById("frown").style.display="block"
    document.getElementById("smile").style.display="none"
   }
   else if(RoleName){

    document.getElementById("ErrA").innerHTML=" "
    document.getElementById("frown").style.display="none"
  document.getElementById("smile").style.display="block"
   }
  }

  //  RoleAction

const[roleAction,setRoleAction] = useState();

function updateRoleAction(Id){
     
  let arr = [];
  let checkboxes = document.querySelectorAll("input[type='checkbox']:checked");
 
 checkboxes.forEach((item)=>{
    arr.push(item.value)
 }) 
console.log(arr)


  var checkboxInput = arr.toString();
     
  const body ={
  
    RoleAction: checkboxInput,      
    Id:Id     
  
   }
   console.log(body);
  
   
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: `${BASE_URL}/oat/UpdateRoleAction`,
       data:body,
       headers: {             
         'Content-Type': 'multipart/form-data' , 
         "Authorization": "Bearer " + `${token}`,
       }
     
     })
     .then((response) =>{
      console.log(response.data);
              
      // toast.success("Assigned!");

      //alert("Assigned Successfully!")
      setcurrentPage(1)
      document.getElementById("AssignSuccess-Oat").style.display="block"
      uncheckAll()
      getRole()
      setTimeout(() => {
        document.getElementById("AssignSuccess-Oat").style.display="none"
       
      }, 3000);
       }) 
      }
      function uncheckAll() {
        var inputs = document.querySelectorAll('.checkboxInput');
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].checked = false;
        }
    }



    //select particular
const [Editoat, setEditoat] =useState([])

function SelectParticular(Id){
const body =
{
  
 id:Id
}
console.log('body',body);


axios({
       method:"POST",
       url :`${BASE_URL}/oat/GetOatParticularRole`,
       data:body, 
       headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + `${token}`,
        }     
    }) 
    

    .then((response) =>{
      console.log(response.data);
 
   
      setEditoat(response.data)
            
      localStorage.setItem("EditData",JSON.stringify(response.data))
      
   })
   .catch(error => {
     console.log(error);
     
   })

}

///confirm delete

function ConfirmDelete(Id){

  SelectParticular(Id)
  setTimeout(() => {
  document.getElementById("modaldeleteForm").style.display = "block";
  },1000);
  
  }

   //function closeform

   function closeForm(){

    document.getElementById("modaldeleteForm").style.display ="None"

  }

  //  deletestatus

function DeleteStatus(Id,Role){

  //confirm delete
  
  
  
  const body ={
  id: Id
  }
  console.log(body)
  axios({
  
  method:"POST",
  url:`${BASE_URL}/oat/DeleteoatRole`,
  data:body,
  headers: {
  "Content-Type" : "application/json",
  "Authorization": "Bearer " + `${token}`
  
  }
  
  })
  .then((response) =>{
  console.log(response.data);
  // toast.info(  "Deleted"+" " + Role +  "!",  {
  // position: "top-center",
  // autoClose: 3200,
  // hideProgressBar: false,
  // closeOnClick: true,
  // pauseOnHover: true,
  // draggable: true,
  // progress: undefined,
  // className: 'toast-message'
  // });

  //alert("Deleted Successfully")
  getRole();
  closeForm();
  setcurrentPage(1)
  document.getElementById("DelSuccess-Oat").style.display="block"
  setTimeout(() => {
    
    document.getElementById("DelSuccess-Oat").style.display="none"
  }, 3000);
  
  
  })
  
  }  

  function openForm(){

    document.getElementById("modalRegisterForm").style.display = "block";
  }

  function closeAddForm(){
    // document.getElementById("AddErrA").innerHTML=" "
    document.getElementById("Roleform").reset()
    document.getElementById("modalRegisterForm").style.display = "none";
    document.getElementById("Roleform").reset();
    document.getElementById("smile").style.display="none"
    document.getElementById("frown").style.display="none"
    document.getElementById("ErrA").innerHTML=" "
  }

  return (
    



      <>
        <div  className='oat-addmain'>

          <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
          
    
          <div className="oat-addgrid-layout">
    
    <div className="oat-addmain-top">
      <div className='oat-addmain-back'>
      
      </div> 
      <span className='OatTitle'>
      <span>ADD ROLE</span></span>
      
      <div className='oat-addmain-back'>
      <Link to="/Oatadduser"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
      </div>
      </div>
        {/* Alert Messages */}
   {/* Added success */}
    
    <div className='oat-toastpop-fade' id="AddSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Added successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
 {/* Delete success */}
    
 <div className='oat-toastpop-fade' id="DelSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Actions Cleared successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>

{/* Assign success */}
    
<div className='oat-toastpop-fade' id="AssignSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Assigned successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>

{/* Role Exist Toast */}

<div className='oat-toastpop-fade' id="RoleExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;Role Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>
     {/* Add Role form */}

     <div className="oat-pop-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
       <div className="modal-dialog" role="document">
          <div className="modal-content" style={{marginTop:"230px"}}>
          <div className="modal-header text-center" style={{borderBottom:"none"}}>
        <h4 className="modal-title w-100 font-weight-bold">ADD ROLES</h4>
        <button type="button" className="close" onClick={closeAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
           
              <form id="Roleform" onSubmit={handlesumbmit}>
              <div className="modal-body mx-4">

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                     <input type="text" className="form-control validate"  id="RoleName" onChange={handlechange} placeholder="Role"></input>
                     <span className='tec-successicon'> <i class="fa fa-smile-o" aria-hidden="true" id="smile"></i></span>
                     <span className='tec-erroricon'> <i class="fa fa-frown-o" aria-hidden="true" id="frown"></i></span>
                    </div>
                    
                     <span id="ErrA" className='error'></span>
                     
                  </div>
                     <span id="Error"></span>
                </div>

                  <div className="modal-footer d-flex justify-content-center">
                        <button type="submit"  className="oat-profile-button">CREATE</button>
                  </div>

           </form>

          </div>
     </div>
    </div>
    <div id="OatButton" style={{marginRight:"50px" ,marginTop:"-35px"}} >
      <div id='oatA-addmain-add' className='col-sm-3'>
      <button className='add-user' id="CourseBtn_Oat" onClick={openForm}><span>Add Roles</span><i></i>
     
       </button>
       </div>
    </div>
    {
 Roletable.length==0  ? (<div id="OatApiFail">" No Data Found "</div>):(
    <div>
    <div className='oattable'>

<div class="oat-table_responsive">

  <table> 
    <thead>
   <tr>
   {/* <th>S.No</th> */}
      <th>Roles</th>
      <th> Assign</th>
      <th style={{whiteSpace:"nowrap"}}> Assigned Action</th>
      <th>Action</th>
     </tr>
    </thead>

    <tbody>

 
    
    {paginatedPosts.map((e)=>
            {
              return<tr>
                {/* <td>{index+1}</td> */}
                <td>{e.role}</td>
                <td style={{whiteSpace:"nowrap"}}> 

       <label><input type="checkbox" className='checkboxInput'   onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Add" />Add 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
       
       <label><input type="checkbox"  className='checkboxInput'   onChange={e=>setRoleAction(e.target.value)} name="optradio" value="View"/>View 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      
       <label><input type="checkbox"  className='checkboxInput'  onChange={e=>setRoleAction(e.target.value)} name="optradio"  value="Edit"/>Edit 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
       
       <label><input type="checkbox"  className='checkboxInput'  onChange={e=>setRoleAction(e.target.value)} name="optradio"  value="Delete"/>Delete 
       </label>&nbsp;&nbsp;&nbsp;&nbsp;
        <button onClick={()=>updateRoleAction(e.id)} id="Oatsetbtn">Set</button>
  
      
       </td>
       {e.roleAction?<td style={{whiteSpace:"nowrap"}}>{e.roleAction}</td>:<td style={{whiteSpace:"nowrap"}}>No Task Assigned</td>}
       <td> 
           
              
             <span><i class="fa fa-refresh" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="tecDelicon"></i></span>
             
              </td>
                 </tr>
            })} 
           

     </tbody>
     </table>

     </div>
    </div> 

    <br></br>
  {pageCount==1?null:<nav id="oatpagenav" style={{marginTop:"30px"}}>
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
  </div>     )} 
      {/* DeletePopup */}

   {Editoat.map((e)=>{ 
   return<div className="oat-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Clear Actions for <br></br><span>{e.role}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="oat-adduser-button" onClick={()=>DeleteStatus(e.id,e.role)} type='submit'>Clear</button>
        <button className="oat-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
    </div>
    </>
  )
}

export default OatAddRolemain
